import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useErrorToast } from "@/lib/hooks";
import { useI18n } from "@/i18n/I18n";

export const ForgotDialog = () => {
  const { t } = useI18n();
  const showErr = useErrorToast();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      toast.success(t("auth.forgotSent"));
      setOpen(false);
    } catch (err) { showErr(err); } finally { setBusy(false); }
  };
  return (
    <>
      <button data-testid="auth-forgot-link" type="button" onClick={() => setOpen(true)} className="text-sm text-blue-700 hover:underline">{t("auth.forgot")}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="forgot-dialog">
          <form onSubmit={send} className="space-y-4">
            <DialogHeader><DialogTitle>{t("auth.forgotTitle")}</DialogTitle></DialogHeader>
            <Input data-testid="forgot-email-input" type="email" className="h-12" placeholder={t("auth.email")} value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
            <DialogFooter><Button data-testid="forgot-submit-button" type="submit" disabled={busy} className="h-11">{t("auth.forgotSend")}</Button></DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
